import {Component} from 'react'
import {withRouter} from 'react-router-dom'

import './index.css'
import FoodContext from '../../FoodContext'

class Counter extends Component {
  state = {
    counter: 1,
  }

  increaseCounter = () =>
    this.setState(prevState => ({counter: prevState.counter + 1}))

  decreaseCounter = () =>
    this.setState(prevState => ({
      counter: prevState.counter - 1,
    }))

  render() {
    let {counter} = this.state
    const {match} = this.props
    const showAddBtn = match.path === '/cart' ? 0 : 1
    return (
      <FoodContext.Consumer>
        {value => {
          const {
            cartItems,
            increaseItemQuantity,
            decreaseItemQuantity,
            delFromCartFunc,
          } = value
          const {counterId, delCounterFunc} = this.props

          // updating counter value according to existing cart item
          const item = cartItems.filter(eachItem => counterId === eachItem.id)
          if (item.length > 0) {
            counter = item[0].quantity
          }

          const onIncrement = () => {
            increaseItemQuantity(counterId)
            this.increaseCounter()
          }

          const onDecrement = () => {
            if (counter > 1) {
              decreaseItemQuantity(counterId)
            } else {
              delFromCartFunc(counterId)
              if (showAddBtn) {
                delCounterFunc()
              }
            }
            this.decreaseCounter()
          }

          return (
            <div className="counter-div">
              <button className="btn" type="button" onClick={onDecrement}>
                -
              </button>
              <div>
                <p className="counter-para">{counter}</p>
              </div>
              <button className="btn" type="button" onClick={onIncrement}>
                +
              </button>
            </div>
          )
        }}
      </FoodContext.Consumer>
    )
  }
}

export default withRouter(Counter)
